import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { connect, useDispatch, useSelector } from 'react-redux';
import * as actions from 'redux/actions/index';
import { validateProfileForm } from 'Utility/validator/formValidation';
import { ProfileformInputTextErrorStyle } from 'Utility/constants';
import Loader from 'react-loader-spinner';
import MyDropZone from '../../Utility/DragandDropImages/DragAndDropImages';
import { decode } from 'base64-arraybuffer';

const Profile = (props) => {
   let dispatch = useDispatch();
   let isLoading = useSelector((state) => state.authReducer.isLoading);
   let isImageUploading = useSelector(
      (state) => state.authReducer.isImageUploading
   );

   const [fileType, setFileType] = useState([]);
   const [imageName, setImageName] = useState([]);
   const [allFileTypes, setAllFileTypes] = useState([]);
   const [base64, setBase64] = useState([]);
   const [imagePreview, setimagePreview] = useState([]);

   const initialFormValues = {
      first_name: props.user.first_name,
      last_name: props.user.last_name,
   };

   let storeImage = require('assets/images/thumbnails/user_placeholder.png');

   const extractExtention = (arr) => {
      let result = [];
      for (var i = 0; i < arr.length; i++) {
         result.push(arr[i].substr(arr[i].lastIndexOf('.')));
      }
      return result;
   };

   useEffect(() => {
      if (base64.length > 0) {
         const image = base64[0].split(',');
         let base_photo = image[1];
         const extentions = extractExtention(imageName);

         const decoded_photo = decode(base_photo);

         dispatch(actions.uploadPhoto(extentions, decoded_photo));
      }
   }, [base64, dispatch, imageName]);

   const updateImageState = (imageName, fileType, allFileTypes) => {
      setImageName([...imageName]);
      setFileType([...fileType]);
      setAllFileTypes([...allFileTypes]);
   };

   const updateBase64 = (base64) => {
      setBase64([...base64]);
      setimagePreview([...base64]);
   };

   if (isImageUploading) {
      storeImage = require('assets/images/gif/spinner.gif');
   } else if (imagePreview && imagePreview.length > 0) {
      storeImage = imagePreview[0];
   } else if (props.user.photo_url && props.user.photo_url.medium) {
      storeImage = props.user.photo_url.medium;
   }

   const ImageUIComponent = (
      <div className="edit_pro_wep">
         <figure className="edit_pro">
            <img src={storeImage} alt="User Profile" />
         </figure>
         <a href="javascript:void(0)"> Change Profile Image</a>
      </div>
   );

   return (
      <div id="wrap">
         <section className="ihWeb_sec theme_nav_mt">
            <div className="container">
               <div className="row">
                  <div className="col-sm-10 mx-auto">
                     <div className="card ihWeb_card">
                        <div className="card-body">
                           <article className="ihWeb_art">
                              <h3 className="border-bottom mb-0 pb-2">
                                 Profile
                              </h3>
                           </article>
                           <Formik
                              initialValues={initialFormValues}
                              onSubmit={(values) => {
                                 if (
                                    props.photo_path &&
                                    props.photo_path.length > 0
                                 ) {
                                    dispatch(
                                       actions.editprofile({
                                          user: {
                                             ...values,
                                             photo_url: props.photo_path[0],
                                          },
                                       })
                                    );
                                 } else {
                                    dispatch(
                                       actions.editprofile({
                                          user: {
                                             ...values,
                                          },
                                       })
                                    );
                                 }
                              }}
                              validate={(values) => validateProfileForm(values)}
                           >
                              {(formik_props) => {
                                 return (
                                    <Form
                                       className="ihWeb_form"
                                       id="profile_form"
                                    >
                                       <fieldset className="mt-3">
                                          <div className="row">
                                             <div className="col-lg-12 text-center">
                                                <div className="edit_pro_wep">
                                                   <MyDropZone
                                                      updateBase64={
                                                         updateBase64
                                                      }
                                                      updateImageState={
                                                         updateImageState
                                                      }
                                                      uploadImagesDirectly={
                                                         true
                                                      }
                                                      imageName={imageName}
                                                      fileType={fileType}
                                                      AllFileTypes={
                                                         allFileTypes
                                                      }
                                                      UIComponent={
                                                         ImageUIComponent
                                                      }
                                                   />
                                                </div>
                                             </div>
                                          </div>
                                          <div className="row">
                                             <div className="col-md-4 col-lg-4">
                                                <div className="form-group">
                                                   <label class="label_modify">
                                                      First Name
                                                   </label>
                                                   <Field
                                                      className="input_modify"
                                                      type="text"
                                                      name="first_name"
                                                   />
                                                   <ErrorMessage
                                                      name="first_name"
                                                      render={(msg) => (
                                                         <span
                                                            style={
                                                               ProfileformInputTextErrorStyle
                                                            }
                                                         >
                                                            {msg}
                                                         </span>
                                                      )}
                                                   />
                                                </div>
                                             </div>

                                             <div className="col-md-4 col-lg-4">
                                                <div className="form-group">
                                                   <label class="label_modify">
                                                      Last Name
                                                   </label>
                                                   <Field
                                                      className="input_modify"
                                                      type="text"
                                                      name="last_name"
                                                   />
                                                   <ErrorMessage
                                                      name="last_name"
                                                      render={(msg) => (
                                                         <span
                                                            style={
                                                               ProfileformInputTextErrorStyle
                                                            }
                                                         >
                                                            {msg}
                                                         </span>
                                                      )}
                                                   />
                                                </div>
                                             </div>
                                             <div className="col-md-4 col-lg-4">
                                                <div className="form-group">
                                                   <label class="label_modify">
                                                      Email
                                                   </label>
                                                   <input
                                                      className="input_modify"
                                                      placeholder={
                                                         props.user.email
                                                      }
                                                      readOnly
                                                   />
                                                </div>
                                             </div>
                                          </div>
                                          <div className="row">
                                             <div className="col-lg-12 text-center">
                                                <button
                                                   disabled={
                                                      isLoading ? true : false
                                                   }
                                                   type="submit"
                                                   className="theme_btn theme_primary MW200"
                                                >
                                                   {isLoading ||
                                                   isImageUploading ? (
                                                      <Loader
                                                         type="Circles"
                                                         color="#FFF"
                                                         height={25}
                                                         width={80}
                                                      />
                                                   ) : (
                                                      'Submit'
                                                   )}
                                                </button>
                                             </div>
                                          </div>
                                       </fieldset>
                                    </Form>
                                 );
                              }}
                           </Formik>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      user: state.authReducer.user,
      photo_path: state.authReducer.photo_path,
   };
};

const RProfile = withRouter(Profile);

export default connect(mapStateToProps)(RProfile);
